// session storage constants
// app helpers
export const ACTIVE_USER = 'ACTIVE_USER';
// refresh helpers - init app without duplicating REST calls
export const ORG_DEFAULT_MODULE_ID = 'ORG_DEFAULT_MODULE_ID';
export const ORG_WEBSITE_BASE_URL = 'ORG_WEBSITE_BASE_URL';
export const MAX_IDLE_TIMEOUT_MINS = 'MAX_IDLE_TIMEOUT_MINS';
export const SESSION_TIMEOUT_MINS = 'SESSION_TIMEOUT_MINS';
export const E360_SESSION = 'E360_SESSION';
export const E360_USER = 'E360_USER';
export const SELECTED_ORG = 'SELECTED_ORG';

// local storage constants
// allows us to check if SSO user closed tab/browser without signing out and handle it
export const COGNITO = 'COGNITO';
export const SIGN_IN_URL = 'SIGN_IN_URL';
export const SSO_SIGN_OUT_MSG = 'SSO_SIGN_OUT_MSG';
export const SSO_USER_SIGNED_IN = 'SSO_USER_SIGNED_IN';
export const NEXT_ORG_E360_URL = 'NEXT_ORG_E360_URL';
export const PARAMS = 'PARAMS';
export const ANNOUNCEMENT_MODAL_DETAILS = 'ANNOUNCEMENT_MODAL_DETAILS';
